module.exports = {
    TTopics: Symbol('TTopics'),
    TDetachable: Symbol('TDetachable'),
};
